module.exports = __webpack_public_path__ + "static/images/containers/ShopView/images/small/package_s.cbebd3bb.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/images/small/package_s.png
// module id = 989
// module chunks = 16